import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import ManageSubscription from "Common/ManageSubscription";
import { useDispatch, useSelector } from "react-redux";
import {
  THEME_MODE,
  THEME_SIDEBAR_TOGGLE,
  changeTheme,
  changeSidebarThemeToggle,
  changeAuthenticated,
  setUser,
} from "Slices/theme/reducer";
import { RootState } from "Slices/theme/store";

//images
// import logo01 from "assets/images/logo/logo-01.png";
import icons01 from "assets/images/icons/01.svg";
import user1 from "assets/images/avatar/user.svg";
import user2 from "assets/images/avatar/user-2.svg";
import BigBarristerLogo from "assets/images/logo/big barrister-1.webp";
// import avatar04 from "assets/images/avatar/legal bot_1.webp";
import avatar04 from "assets/images/banner/02.png";
import { handlingApi } from "units/handlingApi";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faPlus,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

const TopBar = () => {
  const [isUpdateSubscription, setIsUpdateSubscription] =
    useState<boolean>(false);

  const toggleUpdateSubscription = () => {
    setIsUpdateSubscription(!isUpdateSubscription);
  };

  const [isSearch, setIsSearch] = useState(false);

  const toggleSearch = () => {
    setIsSearch(!isSearch);
  };

  const [isNotification, setIsNotification] = useState(false);

  const toggleNotification = () => {
    setIsNotification(!isNotification);
  };

  const [isLanguage, setIsLanguage] = useState(false);

  const toggleLanguage = () => {
    setIsLanguage(!isLanguage);
  };

  const [isProfile, setIsProfile] = useState(false);
  const [confirmLogout, setConfirmLogout] = useState(false);
  const [loading, setLoading] = useState(false);
  const loginPage = window.location.pathname === "/login";

  const toggleProfile = (e: any) => {
    if (!isProfile) {
      setIsProfile((prev) => !prev);
    } else {
      setTimeout(() => {
        setIsProfile((prev) => !prev);
      }, 200);
    }
  };

  const isAuthenticated = useSelector(
    (state: RootState) => state.theme.isAuthenticated
  );

  const themeType = useSelector((state: RootState) => state.theme.themeType);
  const user = useSelector((state: RootState) => state.theme.user);
  // console.log("user", user);
  // console.log("user.fragen topbar", user?.fragen);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  const toggleModeTheme = () => {
    const newTheme =
      themeType === THEME_MODE.LIGHT ? THEME_MODE.DARK : THEME_MODE.LIGHT;
    document.documentElement.setAttribute("data-theme", newTheme);
    dispatch(changeTheme(newTheme));
  };

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", themeType);
  }, [themeType]);

  //Toggle sidebar
  const themeSidebarToggle = useSelector(
    (state: RootState) => state.theme.themeSidebarToggle
  );
  const [isSidebarToggle, setIsSidebarToggle] = useState<boolean>(false);

  // Update isSidebarToggle based on themeSidebarToggle when it changes
  useEffect(() => {
    setIsSidebarToggle(themeSidebarToggle === THEME_SIDEBAR_TOGGLE.TRUE);
  }, [themeSidebarToggle]);

  const toggleSidebar = () => {
    const newToggleValue = !isSidebarToggle;
    setIsSidebarToggle(newToggleValue);
    // Dispatch action based on the new toggle value
    dispatch(
      changeSidebarThemeToggle(
        newToggleValue ? THEME_SIDEBAR_TOGGLE.TRUE : THEME_SIDEBAR_TOGGLE.FALSE
      )
    );
  };

  const handleConfirmLogout = () => {
    setConfirmLogout(true);
  };

  const handleLogout = async () => {
    const token = Cookies.get("token");
    if (token) {
      setLoading(true);
      const url = `${apiBaseUrl}user/logout`;

      try {
        const res = await handlingApi({ url, method: "POST", data: {}, token });

        if (res.statusCode === 200) {
          Cookies.remove("token");
          dispatch(changeAuthenticated(false));
          dispatch(setUser(null));
          localStorage.removeItem("userData");
          setLoading(false);
          setConfirmLogout(false);
          navigate("/");
          toast.success(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };
  return (
    <>
      <div className="header-area-one">
        <div className="container-30">
          <Col lg={12}>
            <div className="header-inner-one py-2">
              <div className="left-logo-area">
                <img
                  src={BigBarristerLogo}
                  alt="logo-image"
                  style={{ height: "60px", width: "170px", cursor: "pointer" , objectFit: "contain" }}
                  onClick={() => navigate("/")}
                />
                {/* <Link to="/" className="logo">
                  <img src={logo01} alt="logo-image" />
                  
                </Link> */}
                <div
                  onClick={toggleSidebar}
                  className={`left-side-open-clouse ${
                    themeSidebarToggle ? "collapsed" : ""
                  }`}
                  id="collups-left"
                >
                  <img src={icons01} alt="icons" />
                </div>
              </div>
              <div className="header-right">
                <div className="action-interactive-area__header">
                  {isAuthenticated ? (
                    <>
                      {user?.fragen === "0" && (
                        <Link to="/pricing" className="add_fragen_btn fs-5">
                          <FontAwesomeIcon icon={faPlus} />{" "}
                          <span className="ms-2">Fragen</span>
                        </Link>
                      )}
                      <div className="single_action__haeader user_avatar__information openuptip">
                        <div
                          onClick={toggleProfile}
                          onBlur={toggleProfile}
                          className="avatar"
                          tabIndex={0}
                        >
                          <div className="px-3 py-2">
                            <span>
                              {user?.fName[0]}
                              {user?.lName[0]}
                            </span>
                          </div>
                        </div>
                        <div
                          style={{ display: isProfile ? "block" : "none" }}
                          className="user_information_main_wrapper slide-down__click"
                        >
                          <div className="user_header">
                            <div className="main-avatar">
                              <div className="px-3 py-2">
                                <span>
                                  {user?.fName[0]}
                                  {user?.lName[0]}
                                </span>
                              </div>
                            </div>
                            <div className="user_naim-information">
                              <h3 className="title">
                                {" "}
                                {user?.fName} {user?.lName}{" "}
                              </h3>
                              <p className="desig">
                                {" "}
                                <span className="fw-bold">
                                  Subscription
                                </span> : {user?.subscription || "Free"}
                              </p>
                            </div>
                          </div>
                          <div className="user_body_content">
                            <ul className="items">
                              <li className="single_items">
                                <Link
                                  className="hader_popup_link"
                                  to="/chatbot"
                                >
                                  <i className="fa fa-robot"></i>
                                  Chatbot
                                </Link>
                              </li>
                              <li className="single_items">
                                <Link
                                  className="hader_popup_link"
                                  to="/profile"
                                >
                                  <i className="fa-light fa-user"></i>
                                  Profile
                                </Link>
                              </li>
                              {/* <li className="single_items">
                              <Link className="hader_popup_link" to="#">
                                <i className="fa-regular fa-gear"></i>
                                Settings
                              </Link>
                            </li> */}
                              {/* <li className="single_items">
                                <Link
                                  className="hader_popup_link"
                                  to="/billing/overview"
                                >
                                  <i className="fa-light fa-person-snowmobiling"></i>
                                  Billing
                                </Link>
                              </li> */}
                              {/* <li className="single_items">
                                <Link
                                  className="hader_popup_link"
                                  to="/activity"
                                >
                                  <i className="fa-solid fa-wave-pulse"></i>
                                  Activity
                                </Link>
                              </li> */}
                              {/* <li className="single_items">
                                <Link className="hader_popup_link" to="#">
                                  <i className="fa-regular fa-bell"></i>
                                  Help
                                </Link>
                              </li> */}
                            </ul>
                          </div>
                          <div className="popup-footer-btn">
                            <button
                              onClick={handleConfirmLogout}
                              className="geex-content__header__popup__footer__link"
                            >
                              Logout
                              <i className="fa-light fa-arrow-right"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : !loginPage ? (
                    <>
                      <Link
                        to='/login'
                        className="chatbot-btn"
                      >
                        Sign In
                      </Link>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </Col>
        </div>
      </div>

      {/* <ManageSubscription
        isUpdateSubscription={isUpdateSubscription}
        toggleUpdateSubscription={toggleUpdateSubscription}
      /> */}

      {confirmLogout && (
        <div style={{ zIndex: "9999999" }} className="popup-overlay">
          <div className="popup-container mt-5">
            <span
              className="close-btn"
              onClick={() => {
                setConfirmLogout(false);
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </span>
            <h3 className="mb-0 mb-md-4 text-center">
              <span>Confirm Logout</span>
            </h3>
            <p className="text-center mb-2">
              Are you sure you want to log out 
            </p>
            <p className="mb-3">of Strafinfo Chatbot? <strong>{user?.email}</strong></p>
            <div className="d-flex justify-content-center gap-3 pt-3">
              <button
                onClick={() => {
                  setConfirmLogout(false);
                }}
                className="btn btn-secondary geex-content__header__popup__footer__link fs-3"
                style={{ padding: "1rem 2rem", borderRadius: "10px" }}
              >
                Cancel
              </button>
              <button
                onClick={handleLogout}
                className="btn btn-primary geex-content__header__popup__footer__link fs-3"
                style={{
                  padding: "1rem 2rem",
                  borderRadius: "10px",
                  marginRight: "1rem",
                }}
                disabled={loading}
              >
                {loading ? (
                  <div className="text-center">
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <>
                    Logout
                    <FontAwesomeIcon icon={faArrowRight} />
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TopBar;
